import axios from '@axios'

export default {
    namespaced: true,
    state: { // State of the ASC
        plantas: [],
        working_lote: null,
        tempLote: null,
        inventarios: [],
        bodegas: [],
        tipos_mov: [],
        item: null,
        search: {
            items_quantity: 0,
            items: [],
        },
        secuencial: null,
        inventarioAsc: null,
        lotesAP: [],
        campiscs: [],
        reporteData: null,

    },
    getters: { // getters, get the value of the state
        getPlantas(state) {
            return state.plantas
        },
        getWorkingLote(state) {
            return state.working_lote
        },
        getTempLote(state) {
            return state.tempLote
        },
        getInventarios(state) {
            return state.inventarios
        },
        getBodegas(state) {
            return state.bodegas
        },
        getTiposMovimientos(state) {
            return state.tipos_mov
        },
        getItem(state) {
            return state.item
        },
        getSearchedItems(state) {
            return state.search.items
        },
        getSearchItemsQuantity(state) {
            return state.search.items_quantity
        },
        getSecuencial(state) {
            return state.secuencial
        },
        getInventarioAsc(state) {
            return state.inventarioAsc
        },
        getLotesAP(state) {
            return state.lotesAP
        },
        getCamPiscs(state) {
            return state.campiscs
        },
        getReporteData(state) {
            return state.reporteData
        },
    },
    mutations: { // setters, modify state
        setPlantas(state, plantas) {
            state.plantas = plantas
        },
        setWorkingLote(state, lote) {
            state.working_lote = lote
        },
        setTempLote(state, temp_lote) {
            state.tempLote = temp_lote
        },
        setInventarios(state, inventarios) {
            state.inventarios = inventarios
        },
        setBodegas(state, bodegas) {
            state.bodegas = bodegas
        },
        setTiposMovimientos(state, tipos) {
            state.tipos_mov = tipos
        },
        setItem(state, item) {
            state.item = item
        },
        setSearchItems(state, items) {
            state.search.items = items
        },
        setSearchItemsQuantity(state, quantity) {
            state.search.items_quantity = quantity
        },
        setSecuencial(state, secuencial) {
            state.secuencial = secuencial
        },
        setInventarioAsc(state, invAsc) {
            state.inventarioAsc = invAsc
        },
        setLotesAP(state, lotes) {
            state.lotesAP = lotes
        },
        setCamPiscs(state, cps) {
            state.campiscs = cps
        },
        setReporteData(state, data) {
            state.reporteData = data
        },
    },

    actions: {
        clean({ commit }) {
            commit('setSecuencial', null)
            commit('setSearchItems', [])
            commit('setSearchItemsQuantity', 0)
        },
        fetchPlantas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/info/plantas')
                    .then(response => {
                        commit('setPlantas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchLoteAsc({ commit }, lote_id) {
            return new Promise((resolve, reject) => {
                // TODO: Clean this after tests
                // let api_route = 'api/auth/controlAsc/'
                // if (lote_id == 'new' || lote_id == '') // TODO: Maybe change the empty string validation
                // { api_route += 'loteAsc_new' } else { api_route += `loteAsc/${lote_id}` }
                const url = lote_id ? `api/auth/controlAsc/loteAscMaster/${lote_id}` : 'api/auth/controlAsc/loteAscMaster'
                axios
                // .get(api_route)
                    .get(url)
                    .then(response => {
                        commit('setWorkingLote', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Realiza una peticion al servidor para que le retorne un lote(fresco, va o reproceso).
         * @param {object} param0 ---
         * @param {object} data Datos para buscar el lote deseado
         * @returns
         */
        fetchLote({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/info/lote', { params: data })
                    .then(response => {
                        commit('setTempLote', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Envia los lotes a que se validen si contienen o no contienen libras
         * disponibles dependiendo de los parametros que se deban tomar en consideracion.
         *
         * @param {object} param0
         * @param {object} lotes Lotes a validar
         * @returns promise devuelta por el servidor del API
         */
        validateLotes({ commit }, lotes) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsc/validarLotes', lotes)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Guarda los cambios de un lote master ASC
         * @param {object} param0 ---
         * @param {object} lote La informacion del lote fresco a guardar
         * @returns
         */
        sendLoteAsc({ commit }, lote) { // TODO: change to lote fresco ASC
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsc/saveLote/asc-master', lote)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Realiza una peticion al API para obtener una lista de inventarios segun los parametros
         * que se consideren necesarios para la busqueda.
         *
         * @param {object} param0 ---
         * @param {object} data datos necesarios para realizar la busqueda al servidor
         * @returns Una promesa que contiene la respuesta del servidor del Backend
         */
        fetchInventarios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/fetchInventarios', { params: data })
                    .then(response => {
                        commit('setInventarios', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Realiza una peticion al servidor del API para obtener una lista de bodegas
         * segun los parametros que se envien en `data`.
         *
         * @param {object} param0 ---
         * @param {object} data Datos clave-valor para la busqueda
         * @returns Una promesa con la respuesta del servidor del API
         */
        fetchBodegas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/info/bodegas', { params: data })
                    .then(response => {
                        commit('setBodegas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Realiza una peticion para obtener una lista de los tipos de movimientos
         * que esten disponibles para los lotes/movimientos de la certificacion ASC.
         *
         * @param {object} param0 ---
         * @returns Una promesa con la respuesta del servidor del API
         */
        fetchTiposMovimientos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/info/tipo-movimientos')
                    .then(response => {
                        commit('setTiposMovimientos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Realiza una peticion al API para obtener una item segun los
         * parametros de busqueda que se consideren necesarios.
         *
         * @param {object} param0 ---
         * @param {object} data datos de busqueda de un item
         * @returns Una promesa con la respuesta del servidor del API.
         */
        fetchItem({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/fetchItem', { params: data })
                    .then(response => {
                        commit('setItem', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Realiza una busqueda sobre los items que se quieran listar de acuerdo a los
         * parametros que se envian en `searchData`.
         *
         * @param {object} param0 ---
         * @param {object} searchData parametros de busqueda
         * @returns Una promesa con la respuesta del servidor del API
         */
        loadSearchItems({ commit }, searchData) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/fetchItems', { params: searchData })
                    .then(response => {
                        const rdata = response.data
                        if (rdata.current_page) {
                            commit('setSearchItems', rdata.data)
                            commit('setSearchItemsQuantity', response.data.total)
                        } else {
                            commit('setSearchItems', response.data)
                            commit('setSearchItemsQuantity', response.data.length)
                        }
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Realiza una peticion al API para obtener una nueva transaccion temporal.
         *
         * @param {object} param0 ---
         * @param {object} data datos para la creacion de una movimiento de inventario
         * @returns Una promesa con la respuesta dle servidor del PAI
         */
        fetchNewTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/createTempTransaction', { params: data })
                    .then(response => {
                        commit('setSecuencial', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Obtinene un movimiento de inventario de a cuerdo a los parametros de busqueda,
         * en la cual lo retorna junto a todo el detalle.
         *
         * @param {object} param0 ---
         * @param {object} data los parametros de busqueda que se necesiten
         * @returns Una promesa con la respuesta del servidor del APi
         */
        fetchInventarioAsc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/fetchInventario', { params: data })
                    .then(response => {
                        commit('setInventarioAsc', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Guarda una movimiento de inventario.
         *
         * @param {object} _ ---
         * @param {object} data Datos del movimiento a guardar.
         * @returns Una promesa con la respuesta del servidor del API
         */
        sendMovimiento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsc/saveMovimiento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Realiza una busqueda de un lote Fresco que sea compatible con los
         * lotes ASC.
         *
         * @param {object} param0 ---
         * @param {object} sdata parametros de busqueda
         * @returns Una promesa que contiene la respuesta del servidor del API
         */
        searchLoteAP({ commit }, sdata) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/fetchLoteAP', { params: sdata })
                    .then(response => {
                        commit('setLotesAP', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Realiza una busqueda de un lote de valor agregado o, en caso contario, un
         * nuevo lote de valor agregado.
         *
         * @param {object} param0 ---
         * @param {object} sdata Parametros de busqueda
         * @returns Una promesa que contiene la respuesta del servidor del API
         */
        searchLoteAPVA({ commit }, sdata) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/fetchLoteVA', { params: sdata })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Realiza una busqueda de un lote de reproceso o, en caso contario, un
         * nuevo lote de valor agregado.
         *
         * @param {object} param0 ---
         * @param {object} sdata Parametros de busqueda
         * @returns Una promesa que contiene la respuesta del servidor del API
         */
        searchLoteAPRP({ commit }, sdata) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/fetchLoteRP', { params: sdata })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Guarda los cambios/datos de un lote fresco que sea compatible con
         * lotes ASC.
         *
         * @param {object} _ ---
         * @param {object} sdata datos del lote fresco
         * @returns Una promesa con la respuesta del servidor del API
         */
        sendLoteAP(_, sdata) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsc/saveLote/fresco', sdata)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Obtiene una lista de lineas que sean compatibles con la certificacion ASC.
         *
         * @param {object} _ ---
         * @returns Una promesa con la respuesta del servidor del API
         */
        fetchLineas(_) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/fetchLineas')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        validarItem(_, itemData) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/validarItem', { params: itemData })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Obtiene un lote fresco segun los parametros especificados.
         *
         * @param {object} _ ---
         * @param {object} loteData parametros de busqueda
         * @returns Una promesa que contiene la respuesta del servidor del API
         */
        fetchLoteFresco(_, loteData) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/info/loteFresco', { params: loteData })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Guarda los datos del lote de Valor agregado.
         *
         * @param {object} _ ---
         * @param {object} loteData Datos del lote a guardar
         * @returns Una promesa que contiene la respuesta del servidor del API
         */
        saveLoteVa(_, loteData) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsc/saveLote/va', loteData)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * Guarda los datos del lote de Reproceso.
         *
         * @param {object} _ ---
         * @param {object} loteData Datos del lote a guardar
         * @returns Una promesa que contiene la respuesta del servidor del API
         */
        saveLoteRP(_, loteData) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlAsc/saveLote/rp', loteData)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchItemsAsc(obj, searchParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlAsc/info/item-asc/${searchParams.tipo}`, { params: searchParams })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCamPiscs({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlAsc/info/cam-piscs')
                    .then(response => {
                        commit('setCamPiscs', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReporte({ commit }, { tipo, data }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`api/auth/controlAsc/reportes/${tipo}`, { params: data })
                    .then(response => {
                        commit('setReporteData', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
